// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wzPh","colBig":"styles_colBig__1Q2z8","colSmall":"styles_colSmall__1u5DT"};